export const DEFAULT_AVATAR_URL = '/images/default-avatar.png';
